import { UserRole } from '../types'

/**
 * Check if a profile has a specific role (supports both single role and multi-role)
 */
export function hasRole(profile: any, role: UserRole): boolean {
  if (!profile) return false
  return profile.role === role || (profile.roles && profile.roles.includes(role))
}

/**
 * Check if a profile has any of the specified roles
 */
export function hasAnyRole(profile: any, roles: UserRole[]): boolean {
  if (!profile) return false
  return roles.some(role => hasRole(profile, role))
}

/**
 * Get the primary role (for backward compatibility)
 */
export function getPrimaryRole(profile: any): UserRole {
  if (!profile) return 'customer'
  return profile.role || (profile.roles && profile.roles[0]) || 'customer'
}

/**
 * Get all roles as an array
 */
export function getAllRoles(profile: any): UserRole[] {
  if (!profile) return []
  if (profile.roles && profile.roles.length > 0) return profile.roles
  if (profile.role) return [profile.role]
  return []
}
